import { createContext, useContext, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

const PRIV = ["owner", "staff", "staf"];

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    try { return JSON.parse(localStorage.getItem("user")); } catch { return null; }
  });

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("token", data.token);
    localStorage.setItem("user", JSON.stringify(data));
    // default cabang: hanya OWNER bisa pindah cabang; lainnya dikunci ke cabangnya
    if (data.role === "owner") localStorage.setItem("branch_id", "all");
    else localStorage.setItem("branch_id", data.branch_id || "all");
    setUser(data);
    return data;
  };

  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    localStorage.removeItem("branch_id");
    setUser(null);
    window.location.href = "/login";
  };

  const isPriv = PRIV.includes(user?.role);
  return (
    <AuthContext.Provider value={{ user, login, logout, isOwner: user?.role === "owner", isPriv }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
